import type { ValorantRank } from 'generated/openapi';
import { memo } from 'react';

import {
  getRankLabel,
  getValorantRankImageUrl,
} from '@/features/games/valorant/utils/rank';
import { ProfileFitIndicator } from '@/features/profile/components/profileFitIndicator';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/shared/components/ui/tooltip';
import { cn } from '@/shared/utils/cn';

export interface ProfileOverviewCardStatsProps {
  rank?: ValorantRank;
  overallCompatibility: number;
  latencyMs: number;
  className?: string;
}

export const ProfileOverviewCardStats = memo(
  (props: ProfileOverviewCardStatsProps) => {
    const { rank, overallCompatibility, latencyMs, className } = props;
    const rankLabel = getRankLabel(rank);
    const rankImageUrl = getValorantRankImageUrl(rank);

    return (
      <div className={cn('flex items-center gap-2', className)}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex size-11 flex-col items-center justify-center rounded-full bg-white/5 text-center shadow-sm backdrop-blur-sm">
              <img
                src={rankImageUrl}
                alt={rankLabel}
                className="size-6 object-contain"
              />
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>Current rank: {rankLabel}</p>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <ProfileFitIndicator progress={overallCompatibility * 100} />
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>
              Fit score.
              <br /> based on vibe & playstyle
            </p>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex size-11 flex-col items-center justify-center rounded-full bg-white/5 text-center shadow-sm backdrop-blur-sm">
              <span className="font-saira text-cold-300 text-center text-xl leading-[110%] font-bold">
                {latencyMs}
              </span>
              <span className="text-cold-300 font-saira text-[10px] leading-[110%] font-bold uppercase">
                ms
              </span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>Estimated latency to player</p>
          </TooltipContent>
        </Tooltip>
      </div>
    );
  },
);
